import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitojaipurcab() {



const cardData = {
  keyword: " Mumbai to Jaipur Cab",

headingDescription:
  "Omshree Cab provides reliable and comfortable Mumbai to Jaipur cab services for travelers planning a long-distance road journey to the vibrant Pink City of Rajasthan. Jaipur is famous for its majestic forts, palaces, rich cultural heritage, bustling markets, and royal architecture. Whether you are planning a family vacation, a cultural tour, a honeymoon trip, or a corporate visit, our cab service ensures a safe and enjoyable journey with experienced drivers and well-maintained vehicles. The road distance from Mumbai to Jaipur is approximately 1,160 km and offers scenic views of western Maharashtra and Rajasthan landscapes along the route. We provide flexible booking options including one-way rides, round-trip packages, and multi-day travel plans with transparent per-kilometer pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With punctual pickups from anywhere in Mumbai, professional chauffeurs skilled in long-distance highway travel, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Jaipur cab booking.",

topPlaces: [
  {
    title: "Amber Fort",
    description:
      "Amber Fort is a magnificent hilltop fort located on the outskirts of Jaipur, known for its artistic Hindu architecture, large courtyards, and intricate mirror work. Visitors can explore the palaces, temples, and gardens within the fort complex, enjoy panoramic views of Maota Lake, and experience cultural performances held inside the fort. A cab ride from Mumbai allows travelers to comfortably include Amber Fort in their Jaipur sightseeing itinerary, giving ample time for photography and exploration."
  },
  {
    title: "City Palace",
    description:
      "City Palace, located in the heart of Jaipur, is an opulent palace complex combining Mughal and Rajasthani architectural styles. The palace houses museums, courtyards, and royal chambers showcasing historical artifacts, weapons, textiles, and paintings. Visitors can learn about Jaipur’s royal history while admiring intricate architecture and beautiful gardens. Traveling by cab ensures convenient access and a relaxed visit to this iconic landmark."
  },
  {
    title: "Hawa Mahal",
    description:
      "Hawa Mahal, also known as the Palace of Winds, is a five-story pink sandstone structure famous for its unique façade with hundreds of small windows (jharokhas). Built to allow royal women to observe street life discreetly, it is now a top tourist attraction. Visitors can explore the interior, capture stunning photographs, and enjoy views of Jaipur city. A cab journey from Mumbai ensures hassle-free travel and time to explore this architectural marvel."
  },
  {
    title: "Jantar Mantar",
    description:
      "Jantar Mantar is a UNESCO World Heritage Site in Jaipur featuring a collection of astronomical instruments built in the 18th century. The observatory allows visitors to understand ancient Indian astronomical knowledge and measurement techniques. It is an educational and cultural experience for travelers interested in science, history, and architecture. Traveling by cab from Mumbai provides a comfortable option to include this historic site in your itinerary."
  },
  {
    title: "Nahargarh Fort",
    description:
      "Nahargarh Fort, perched on the Aravalli hills, offers breathtaking views of Jaipur city, especially during sunset. The fort was historically used as a retreat for the royal family and now attracts tourists for its scenic vistas and historic significance. Visitors can explore the fort’s architecture, enjoy photography, and relax at the fort’s open spaces. A cab trip from Mumbai allows a seamless journey to this elevated viewpoint."
  },
  {
    title: "Jaigarh Fort",
    description:
      "Jaigarh Fort is a historic fort near Amber Fort, famous for housing the world’s largest cannon on wheels, Jaivana, and for its massive stone walls. The fort provides panoramic views of the surrounding hills and Amber Fort below. Visitors interested in history, military architecture, and scenic landscapes can explore its courtyards, temples, and watchtowers. A cab ride from Mumbai ensures a convenient visit as part of a Jaipur sightseeing tour."
  },
  {
    title: "Albert Hall Museum",
    description:
      "Albert Hall Museum, also called the Government Central Museum, is the oldest museum in Rajasthan, located in Jaipur’s Ram Niwas Garden. It features a rich collection of paintings, carpets, sculptures, and artifacts from Rajasthan and across India. Visitors can explore the museum to learn about local art, history, and culture. Traveling by cab allows tourists to comfortably include this cultural attraction in their Jaipur itinerary."
  },
  {
    title: "Birla Mandir",
    description:
      "Birla Mandir is a modern white marble temple dedicated to Lord Vishnu and Goddess Lakshmi. Known for its serene atmosphere and striking architecture, it attracts both devotees and tourists. Visitors often admire the temple’s carvings, attend prayers, and enjoy peaceful surroundings. A cab journey from Mumbai allows travelers to visit this temple without transportation hassles."
  },
  {
    title: "Chokhi Dhani",
    description:
      "Chokhi Dhani is a cultural village resort in Jaipur where visitors can experience traditional Rajasthani food, folk dances, puppet shows, camel rides, and other cultural activities. It is ideal for families and travelers looking to immerse themselves in Rajasthan’s culture. A cab trip from Mumbai allows tourists to conveniently reach this entertainment and cultural hub."
  },
  {
    title: "Shopping at Johari and Bapu Bazaars",
    description:
      "Johari Bazaar and Bapu Bazaar are famous shopping destinations in Jaipur for traditional Rajasthani handicrafts, jewelry, textiles, and souvenirs. Visitors can shop for colorful fabrics, handcrafted jewelry, pottery, and more while enjoying the bustling market atmosphere. Traveling by cab from Mumbai ensures easy access and comfortable transport for shopping enthusiasts."
  }
],



services: [
{
name: "Mumbai to Jaipur Cab",
description: "Mumbai to Jaipur cab service provides comfortable long-distance transportation between Mumbai and the historic Pink City of Jaipur. This interstate journey is popular among tourists, business travelers, and families planning Rajasthan trips. Our well-maintained vehicles ensure safe highway travel with spacious seating and luggage capacity for long journeys. Professional drivers with interstate route experience guarantee smooth and secure travel throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and Mumbai airport terminals. Air-conditioned vehicles ensure relaxed travel even during long-distance road trips. Ideal for tourism visits, heritage travel, and family holidays. Flexible travel plans and reliable service make the journey comfortable and convenient."
},
{
name: "Mumbai to Jaipur Taxi",
description: "Mumbai to Jaipur taxi service offers dependable intercity transportation for passengers traveling between Maharashtra and Rajasthan. The route is suitable for tourists visiting Jaipur forts, palaces, and cultural landmarks. Vehicles provide smooth highway performance and comfortable seating suitable for long-distance travel. Professional drivers ensure punctual pickup and safe interstate driving throughout the journey. Pickup services are available across Mumbai including homes, hotels, offices, railway stations, and airport terminals. Air-conditioned vehicles ensure comfortable travel for passengers and families. Ideal for tourism travel, business trips, and long road journeys."
},
{
name: "Mumbai to Jaipur Cab Service",
description: "Mumbai to Jaipur cab service offers reliable transportation for travelers visiting the capital city of Rajasthan. Jaipur is famous for attractions like Hawa Mahal, Amber Fort, and City Palace. Our vehicles are designed for long-distance highway journeys with comfortable seating and sufficient luggage space. Professional drivers ensure punctual pickup services and safe driving during interstate travel. Pickup is available across Mumbai including homes, offices, hotels, railway stations, and airport terminals. Ideal for tourism tours, family vacations, and business travel."
},
{
name: "Mumbai to Jaipur Taxi Service",
description: "Mumbai to Jaipur taxi service provides convenient road transportation for passengers traveling to Jaipur for tourism, business, or family visits. Vehicles provide comfortable seating and smooth ride quality suitable for long highway journeys. Professional drivers ensure punctual pickup services and safe driving across interstate routes. Pickup services are available from homes, offices, hotels, railway stations, and Mumbai airport terminals. Ideal for tourism travel, corporate visits, and Rajasthan holiday trips."
},
{
name: "Cab from Mumbai to Jaipur",
description: "Cab from Mumbai to Jaipur provides comfortable long-distance travel for passengers planning interstate journeys to Rajasthan. Vehicles offer spacious seating and reliable highway performance suitable for extended travel hours. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for tourism tours, family vacations, and business travel."
},
{
name: "Taxi from Mumbai to Jaipur",
description: "Taxi from Mumbai to Jaipur offers dependable transportation for travelers visiting Jaipur for tourism, cultural visits, or business travel. Vehicles provide comfortable seating and smooth ride quality for long-distance journeys. Professional drivers ensure safe interstate driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals."
},
{
name: "Mumbai to Jaipur Cab Booking",
description: "Mumbai to Jaipur cab booking allows travelers to easily reserve vehicles for long-distance interstate travel. Online and phone booking options provide instant confirmation and flexible travel scheduling. Vehicles provide comfortable seating and reliable highway performance suitable for extended journeys. Professional drivers ensure punctual pickup services across Mumbai."
},
{
name: "Mumbai to Jaipur Taxi Booking Online",
description: "Mumbai to Jaipur taxi booking online provides quick and convenient reservations for travelers planning Rajasthan trips. Passengers can schedule rides online and receive instant booking confirmation. Vehicles provide comfortable seating and smooth highway performance suitable for long-distance travel."
},
{
name: "Mumbai to Jaipur Cab Price",
description: "Mumbai to Jaipur cab price options provide transparent fare estimates based on vehicle category, travel distance, and trip duration. Travelers can choose sedans, SUVs, or MPV vehicles depending on comfort needs and group size. Transparent pricing ensures clarity in billing for interstate travel."
},
{
name: "Mumbai to Jaipur Taxi Fare",
description: "Mumbai to Jaipur taxi fare services offer flexible pricing depending on vehicle type and travel duration. Passengers can choose economical sedans or spacious SUVs depending on travel preferences. Clear fare structure ensures transparent travel pricing."
},
{
name: "Mumbai to Jaipur One Way Cab",
description: "Mumbai to Jaipur one way cab service provides economical interstate transportation without return charges. Vehicles provide comfortable seating and smooth highway performance suitable for long-distance travel. Ideal for travelers planning one-way tourism or relocation trips."
},
{
name: "Mumbai to Jaipur Round Trip Taxi",
description: "Mumbai to Jaipur round trip taxi service provides convenient travel options for passengers planning return journeys after visiting Jaipur. Vehicles remain available for the complete journey and ensure comfortable highway travel for both directions."
},
{
name: "Mumbai to Jaipur Innova Cab",
description: "Mumbai to Jaipur Innova cab service provides spacious MPV transportation ideal for families and small groups traveling long distances. Toyota Innova vehicles offer comfortable seating and reliable highway performance suitable for interstate travel."
},
{
name: "Mumbai to Jaipur Ertiga Cab",
description: "Mumbai to Jaipur Ertiga cab service provides comfortable MPV travel for families and small groups visiting Rajasthan. The Maruti Ertiga offers spacious seating and smooth ride quality suitable for extended highway journeys."
},
{
name: "Mumbai to Jaipur Sedan Cab",
description: "Mumbai to Jaipur sedan cab service provides economical and comfortable transportation for passengers traveling long distances. Sedan vehicles offer smooth ride quality, air-conditioned interiors, and comfortable seating suitable for tourism and business travel."
}
],

tableData: [
["Mumbai to Jaipur Cab","Mumbai to Jaipur Taxi"],
["Mumbai to Jaipur Cab Service","Mumbai to Jaipur Taxi Service"],
["Cab from Mumbai to Jaipur","Taxi from Mumbai to Jaipur"],
["Mumbai to Jaipur Cab Booking","Mumbai to Jaipur Taxi Booking Online"],
["Mumbai to Jaipur Cab Price","Mumbai to Jaipur Taxi Fare"],
["Mumbai to Jaipur One Way Cab","Mumbai to Jaipur Round Trip Taxi"],
["Mumbai to Jaipur Innova Cab","Mumbai to Jaipur Ertiga Cab"],
["Mumbai to Jaipur Sedan Cab","Jaipur Taxi from Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Interstate Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in long-distance interstate travel from Mumbai to Jaipur. They are familiar with major highways across Maharashtra, Gujarat, and Rajasthan, ensuring a safe and comfortable journey."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Omshree Cabs offers transparent pricing for Mumbai to Jaipur cab bookings. Customers receive clear details about per-kilometer charges, toll fees, and driver allowance before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Service",
    WhyChoosedescription: "Our Mumbai to Jaipur cab service operates 24 hours a day. Whether you want to start early morning or travel overnight, we provide reliable cab booking anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are well maintained, regularly cleaned, and fully air-conditioned to ensure passengers enjoy a comfortable long-distance journey."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Packages",
    WhyChoosedescription: "We offer flexible travel options including one-way cab bookings, round trips, and multi-day travel packages from Mumbai to Jaipur."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, luxury vehicles like Innova Crysta, and Tempo Travellers suitable for families and group travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and airports anywhere in Mumbai so your Jaipur journey begins smoothly."
  },
  {
    WhyChooseheading: "Trusted Long Distance Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for long-distance trips from Mumbai to Jaipur. Our punctual drivers, comfortable vehicles, and professional service ensure a safe and enjoyable journey."
  }
]
};

const faqData = [
  { question: "Do you provide cab service from Mumbai to Jaipur?", answer: "Yes, Omshree Cabs provides reliable cab services from Mumbai to Jaipur for both one-way and round-trip travel." },
  { question: "What is the distance from Mumbai to Jaipur?", answer: "The distance from Mumbai to Jaipur is approximately 1150 km and the journey usually takes around 18 to 20 hours depending on traffic and road conditions." },
  { question: "Can I book a one-way cab from Mumbai to Jaipur?", answer: "Yes, we offer both one-way and round-trip cab services between Mumbai and Jaipur." },
  { question: "Which vehicles are available for this route?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers depending on group size." },
  { question: "Is the cab service available 24 hours?", answer: "Yes, our Mumbai to Jaipur cab service operates 24/7 for passenger convenience." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can we stop during the journey?", answer: "Yes, passengers can request stops during the journey for meals, rest, or refreshments." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially for long-distance interstate travel." },
  { question: "Do you provide pickup from Mumbai Airport?", answer: "Yes, we provide pickup from Mumbai Airport for travelers heading to Jaipur." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rajesh Sharma",
    feedback:
      "We booked Omshree Cabs for our Mumbai to Jaipur trip. The driver was professional and the long journey was very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Singh",
    feedback:
      "Excellent long-distance cab service. Clean car, punctual driver, and smooth travel from Mumbai to Jaipur.",
    rating: 5
  }
];










































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Jaipur Cab",
  "description": "Omshree Cab provides safe and comfortable cab services from Mumbai to Jaipur, including one-way trips, round trips, and outstation travel. Choose from Innova, Ertiga, or Sedan cabs for a reliable journey. Flexible booking options with transparent pricing.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "920"
  }
};









  return (
    <div>
      
<Helmet>
  <title>Mumbai to Jaipur Cab | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to Jaipur cab with Omshree Cab for one-way, round trip, and outstation travel. Travel comfortably in Innova, Ertiga, or Sedan. Safe and reliable cab service with flexible booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/74.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitojaipurcab;